import React, { useState } from 'react';
import SelectDynamicPaginationField from '../SelectDynamicPaginationField';

const Dynamicpaginationandmultiselect = ({
  api = '',
  value = [],           // array of selected item objects
  onChange = () => { },  // returns array of selected objects
  placeholder = 'Select Item',
  withImage = false,
  disabled = false,
  clearable = false,
}) => {
  // key trick: increment to reset the dropdown after each selection
  const [dropdownKey, setDropdownKey] = useState(0);

  const handleSelect = (option) => {
    if (!option || !option.id) return;

    // Avoid duplicates
    const alreadyExists = value.find((item) => item.id === option.id);
    if (alreadyExists) {
      // Reset dropdown and return
      setDropdownKey((prev) => prev + 1);
      return;
    }

    const updated = [...value, option];
    onChange(updated);

    // ✅ Reset dropdown to null so user can select another item
    setDropdownKey((prev) => prev + 1);
  };

  const handleRemove = (id) => {
    const updated = value.filter((item) => item.id !== id);
    onChange(updated);
  };

  const handleClearAll = () => {
    onChange([]);
    setDropdownKey((prev) => prev + 1);
  };

  return (
    <div className="multi-item-select">
      {/* Dropdown — resets after each selection via key */}
      <SelectDynamicPaginationField
        key={dropdownKey}
        api={api}
        value={null}                        // always null so it stays "empty"
        handleChange={handleSelect}
        placeholder={placeholder}
        withImage={withImage}
        disabled={disabled}
        clearable={clearable}
        addButton={false}
        selecteditem={value.map((x) => x.id)} // ✅ hides already selected items in dropdown
      />

      {/* Selected Tags */}
      {value.length > 0 && (
        <div className="multi-item-select__tags" style={{ marginTop: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
            <span style={{ fontSize: 12, color: '#666' }}>
              {value.length} item(s) selected
            </span>
            <button
              onClick={handleClearAll}
              style={{ color: 'red', fontSize: 12, textDecoration: 'underline' }}
            >
              Clear All
            </button>
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {value.map((item) => (
              <div
                key={item.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  background: '#f0f0f0',
                  borderRadius: 4,
                  padding: '4px 8px',
                  fontSize: 12,
                }}
              >
                <span>{item.name}</span>
                {item.sku && (
                  <span style={{ color: '#888' }}>({item.sku})</span>
                )}
                <button
                  onClick={() => handleRemove(item.id)}
                  style={{ color: 'red', fontWeight: 'bold', marginLeft: 4 }}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dynamicpaginationandmultiselect;